<template>
  <div
    class="column flex mb-4 registration-padding"
    :class="{ mobile: $vuetify.breakpoint.smAndDown }"
  >
    <div class="column flex relative" style="max-width: 840px">
      <h1
        class="row headline tournament-light-blue--text align-center"
        style="height: 90px"
      >
        Confirme sua inscrição
      </h1>

      <!-- Team selected -->
      <div class="border-bottom">
        <!-- Team name -->
        <div
          v-if="team.name"
          class="row subheading mb-2"
          style="font-weight: 500"
        >
          <div class="tournament-dark-blue--text mr-1">
Equipe inscrita:
</div>
          <div class="tournament-dark-grey--text">
            {{ team.name }}
          </div>
        </div>

        <!-- Team name -->
        <div v-if="team.alias" class="row subheading" style="font-weight: 500">
          <div class="tournament-dark-blue--text mr-1">
Número da equipe:
</div>
          <div class="tournament-dark-grey--text">
#{{ team.alias }}
</div>
        </div>

        <div class="row mt-2 mb-3 tournament-grey--text">
          Você poderá inscrever integrantes assim que confirmar a inscrição da
          equipe
        </div>
      </div>

      <!-- Event selected -->
      <div class="mt-4 mb-4">
        <!-- event name -->
        <div
          v-if="event.name"
          class="row subheading mb-2"
          style="font-weight: 500"
        >
          <div class="tournament-dark-blue--text mr-1">
Evento inscrita:
</div>
          <div class="tournament-dark-grey--text">
            {{ event.name }}
          </div>
        </div>

        <!-- Event Kind -->
        <div
          v-if="event.event && event.event.kind && event.event.kind.label"
          class="row subheading mb-2"
          style="font-weight: 500"
        >
          <div class="tournament-dark-blue--text mr-1">
Etapa:
</div>
          <div class="tournament-dark-grey--text">
            {{ event.event.kind.label }}
          </div>
        </div>

        <!-- Event Location -->
        <div
          v-if="
            event.event && event.event.address && event.event.address.address
          "
          class="row subheading mb-2"
          style="font-weight: 500"
        >
          <div class="tournament-dark-blue--text mr-1">
Local:
</div>
          <div class="tournament-dark-grey--text">
            {{ event.event.location ? `${event.event.location} - ` : ""
            }}{{ event.event.address.address
            }}{{
              event.event.address.number
                ? `, ${event.event.address.number}`
                : ""
            }}
          </div>
        </div>

        <!-- Event City -->
        <div
          v-if="event.event && event.event.address && event.event.address.city"
          class="row subheading mb-2"
          style="font-weight: 500"
        >
          <div class="tournament-dark-blue--text mr-1">
Cidade:
</div>
          <div class="tournament-dark-grey--text">
            {{ event.event.address.city }}, {{ event.event.address.state }}
          </div>
        </div>

        <!-- Event Date -->
        <div
          v-if="event.event && event.event.startDate && event.event.endDate"
          class="row subheading mb-2"
          style="font-weight: 500"
        >
          <div class="tournament-dark-blue--text mr-1">
Data:
</div>
          <div class="tournament-dark-grey--text">
            {{
              event.event.startDate
                | FormatEventDate(event.event.endDate, "long")
            }}
          </div>
        </div>

        <!-- Event Hour -->
        <!--         <div class="row subheading mb-2" v-if='event.event && event.event.startDate && event.event.endDate' style="font-weight: 500">
          <div class="tournament-dark-blue--text mr-1">Horário:</div>
          <div class="tournament-dark-grey--text">{{ event.event.startDate | FormatDate('HH') }}h às {{ event.event.endDate | FormatDate('HH') }}h</div>
        </div> -->

        <!-- Event Fee -->
        <div
          v-if="event.registration && event.registration.fee"
          class="row subheading mb-2"
          style="font-weight: 500"
        >
          <div class="tournament-dark-blue--text mr-1">
Taxa de inscrição:
</div>
          <div
            v-if="event.registration.fee == 0"
            class="tournament-green--text"
          >
            GRATUITO
          </div>
          <div v-else class="tournament-dark-grey--text">
            {{ event.registration.fee }}
          </div>
        </div>
      </div>

      <!-- Notes -->
      <div v-if="event.registration && event.registration.notes" class="mb-4">
        <div
          class="tournament-dark-blue--text subheading"
          style="font-weight: 500"
        >
          Observações da organização:
        </div>
        <div class="row mb-3 tournament-dark-grey--text">
          {{ event.registration.notes }}
        </div>
      </div>

      <div class="mb-5">
        <el-button
          class="tournament-dark-blue tournament-white--text rounded no-border mb-2"
          @click.native="cancel()"
        >
          CANCELAR
        </el-button>
        <el-button
          :loading="loading"
          class="tournament-green tournament-white--text rounded no-border"
          style="margin-left: 0px"
          @click.native="confirm()"
        >
          CONFIRMAR INSCRIÇÃO
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapState } from "vuex";

export default {
  name: "Confirm",

  components: {},

  props: {
    team: {
      type: Object,
      required: true,
    },
    event: {
      type: Object,
      required: true,
    },
    judge: {
      type: Object,
      default: () => {},
    },
    loading: {
      type: Boolean,
    },
  },

  computed: {
    ...mapState(["isJudge", "community"]),
  },

  methods: {
    cancel() {
      this.$emit("cancelEnrollment");
    },

    confirm() {
      const eventId = _.get(this.event, "_id", null);
      let teamId = _.get(this.team, "_id", null);

      this.$store.dispatch("getUserInfo", () => {
        this.$store.dispatch("updateMe");

        const userId = _.get(this.userInfo, "_id", null);
        if (userId) teamId = userId;
      });

      if (!eventId || !teamId) return;
      const title = this.isJudge
        ? "Tem certeza que deseja se inscrever neste torneio?"
        : "Tem certeza que deseja inscrever sua equipe neste torneio?";

      this.$dialog({
        width: this.$vuetify.breakpoint.xsOnly ? "95%" : "370px",
        title,
        buttons: [
          { name: "Cancelar", class: "tournament-semi-black--text ma-0" },
          {
            name: "Confirmar",
            action: "submit",
            class: "tournament-green--text ma-0",
          },
        ],
        customClass: "tournament-white pa-4",
        top: "30vh",
      })
        .then(() => {
          this.$emit("updateLoading", true);
          this.$emit("confirmRegistration", {
            eventId: eventId,
            teamId: teamId,
            judge: this.judge,
          });
        })
        .catch(() => {});
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Registration/Steps/Confirm.vue